import { fetchEndpoint } from '../network'

/**
 * 首页管理 - 推荐管理
 */

export default {

	  // 列表
  	list(params) {
    	return fetchEndpoint(
    		'/create-platform/shop',
    		'GET',
    		params
    	)
  	},

    // 详情
    detail(params) {
      return fetchEndpoint(
        '/create-platform/shop/detail',
        'GET',
        params
      )
    },

    // 创建
    create(params) {
      return fetchEndpoint(
        '/create-platform/shop',
        'POST',
        params
      )
    },

    // 修改
    modify(params) {
      return fetchEndpoint(
        '/create-platform/shop/modify',
        'POST',
        params
      )
    },


    // 删除
    remove(params) {
      return fetchEndpoint(
        '/create-platform/shop/delete',
        'POST',
        params
      )
    }

}









 